import styled from 'styled-components';

import { PADDING_PAGE } from '../../../globals';


export const StyledOfficesContent = styled.div`
  padding: ${PADDING_PAGE}px;

  .office-content-row {
    margin: 0px;
  }
}
`;
